<template>
  <Modal
    :tracking="{ topicKey: 'enable-location-services' }"
    @cancel="onCancel"
    @confirm="onConfirm"
  >
    <template #headline>
      {{ $t('compliance.geocheck.permission.modal.headline') }}
    </template>
    <i18n-t :keypath="messageKey" scope="global" tag="p">
      <template #contactSupport>
        <HyperLink class="text-link no-wrap" :href="$localePath('/service?chat=true')">
          {{ $t('common.sentences.contactsupport').toLowerCase() }}
        </HyperLink>
      </template>
      <template #faq>
        <HyperLink
          class="text-link"
          href="https://support.lotto.com/hc/en-us/sections/360011202734-Enabling-Location-Services"
          target="_blank"
        >
          {{ $t('common.words.enablinglocationservices') }}
        </HyperLink>
      </template>
    </i18n-t>
    <template #confirm>
      {{ $t('compliance.geocheck.permission.modal.confirm') }}
    </template>
  </Modal>
</template>

<script lang="ts" setup>
import type { TrackingImpressionProps } from '#tracking/app/types/tracking'

type ComplianceLocationPermissionProps = {
  addFundsEnabled?: boolean
}
type ModalEmit = {
  (e: 'cancel' | 'confirm'): void
}
const props = defineProps<
  ComplianceLocationPermissionProps & {
    trackingAction: TrackingImpressionProps['tracking']['action']
  }
>()
const emit = defineEmits<ModalEmit>()

const onConfirm = () => {
  emit('confirm')
}

const onCancel = () => {
  emit('cancel')
}

const messageKey = computed(() =>
  props.addFundsEnabled
    ? 'compliance.geocheck.permission.addfunds.modal.message'
    : 'compliance.geocheck.permission.modal.message',
)
</script>

<style lang="scss" scoped>
.no-wrap {
  white-space: nowrap;
}
</style>
